import { makeSvgIcon } from '../makeSvgIcon'

export const moon = makeSvgIcon(
  <path d="M20.5978 5.49787C19.7945 5.17668 18.9179 5 18 5C14.134 5 11 8.13401 11 12C11 15.866 14.134 19 18 19C18.9179 19 19.7945 18.8233 20.5978 18.5021C18.7637 20.6432 16.0403 22 13 22C7.47715 22 3 17.5228 3 12C3 6.47715 7.47715 2 13 2C16.0403 2 18.7637 3.35677 20.5978 5.49787Z" />
)
